import constants from '@/constants'
import { createMicroserviceClient } from './microservice'

const baseURL = constants().notificationServer

export default createMicroserviceClient({ baseURL, orgMode: 'orgJwt' })
